module.exports = __webpack_public_path__ + "assets/6ed5807a24a357e7172aac1d8f9be74f.png";